import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { useShallow } from 'zustand/react/shallow'
import { useApplyStore } from '../../stores/ui/applyStore'
import { Button, Teaser } from '../ui'
import ButtonColor from '../ui/buttonColor'
import { OfferCTAProps } from './OfferCTA'
import Logo from '../ui/logo'
import HeaderMedia from '../firms/headerMedia'

interface OfferCTATeaserProps extends OfferCTAProps {
  offerId: string
  title?: string
  buttonLabel?: string
  firmLogoUrl?: string
  header?: string
}

export const OfferCTATeaser = ({
  data,
  color,
  title,
  buttonLabel = undefined,
  offerId,
  firmLogoUrl = '/Logo_V_Lamacompta.jpg',
  header = undefined,
}: OfferCTATeaserProps) => {
  const openApplicationFormModal = useApplyStore(
    useShallow((state) => state.openApplicationFormModal),
  )

  const handleClick = () => {
    openApplicationFormModal({
      offerId,
      colorCareerSite: color || undefined,
      isCareerSiteApply: true,
    })
  }

  if (!offerId) {
    return null
  }

  const label = buttonLabel || `Postuler`

  return (
    <Teaser
      header={
        header ? (
          <HeaderMedia url={header} name={`${data.title}`} />
        ) : (
          <StaticImage
            src="../../../static/cta-header-media.jpg"
            alt="header lamacompta"
            placeholder="blurred"
            formats={['webp']}
            layout="constrained"
            className="object-cover w-full h-full"
          />
        )
      }
      logo={<Logo image={firmLogoUrl} alt={data.title} additionalClasses='object-contain' />}
      type="offer"
    >
      <div className="flex flex-row items-center">
        <div className="my-4 ml-2 font-semibold text-center md:my-0 text-md lg:text-xl lg:text-start grow">
          {title || `Postuler au poste de ${data.title}`}
        </div>
        <div className="hidden lg:block">
          {color ? (
            <ButtonColor
              color={color}
              label={label}
              invert
              size="medium"
              onClick={handleClick}
            />
          ) : (
            <Button
              label={label}
              color="primary"
              invert
              size="medium"
              onClick={handleClick}
            />
          )}
        </div>
      </div>
    </Teaser>
  )
}
